<template>
  <div v-if="isLoading" class="w-100" style="height: 200px;">
    <div class="loader m-auto"></div>
  </div>
  <div v-else>
    <table class="table table-striped">
      <thead>
        <tr>
          <th scope="col"><span class="h5 font-weight-bold">#</span></th>
          <th scope="col"><span class="h5 font-weight-bold">{{ $t("message.case_filling_info.search_input") }}</span></th>
          <th scope="col"><span class="h5 font-weight-bold">{{ $t("message.case_filling_info.page") }}</span></th>
          <th scope="col"><span class="h5 font-weight-bold">{{ $t("message.case_filling_info.vocabulary.search_type")}}</span></th>
          <th scope="col"><span class="h5 font-weight-bold">{{ $t("message.case_filling_info.date")}}</span></th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(hist, index) in histories">
          <td class="small" scope="row"><span class="h6">{{ page * (index + 1) }}</span></td>
          <td class="small"><span class="h6">{{ hist.keyword }}</span></td>
          <td class="small"><span class="h6">{{ hist.page }}</span></td>
          <td class="small">
            <span class="h6">
              {{ hist.caseIdentity === "1" ? $t("message.case_filling_info.vocabulary.defendant") : $t("message.case_filling_info.vocabulary.prosecutor") }}
            </span>
          </td>
          <td class="small"><span class="h6">{{ hist.date }}</span></td>
          <td>
            <button class="btn btn-primary btn-sm p-0 h-auto" @click="() => handleToggleDetail(hist.response)">
              <span class="m-0 px-3 py-2">{{ $t("message.case_filling_info.view") }}</span>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <div style="width: 100%; display: flex; justify-content: center; gap: 10px">
      <button class="btn btn-primary btn-sm p-0 h-auto" @click="prevPage" :disabled="page <= 1">
        <span class="m-0 px-3 py-2">{{ $t("message.case_filling_info.back") }}</span>
      </button>
      <button class="btn btn-primary btn-sm p-0 h-auto" @click="nextPage" :disabled="histories.length < 10">
        <span class="m-0 px-3 py-2">{{ $t("message.case_filling_info.next") }}</span>
      </button>
    </div>
    <b-modal v-model="modalShow" hide-footer lazy size="xl">
      <template v-if="response">
        <div class="mr-0 ml-auto mb-3" style="width: fit-content">
          <js-pdf :pageMarginsInPx="[30, 30, 30, 30]" :pageFullWidthInPx="1400" :filename="'detail.pdf'">
            <template v-slot="pdfProps">
              <itemsList
                :data="response.Result.Data"
                :imLoaded="pdfProps.childFullyLoaded"
              />
            </template>
          </js-pdf>
        </div>
        <itemsList :data="response.Result.Data" />
      </template>
    </b-modal>
  </div>
</template>
<script>

import ItemsList from "./itemsList.vue";
export default {
  name: "History",
  components: { ItemsList },
  data() {
    return {
      isLoading: true,
      response: null,
      modalShow: false,
      page: 1,
      histories: [
        // {
        //   "id": "3979",
        //   "user_id": "b1af899d-ebd8-4e63-8250-7f1eb6c8c956",
        //   "search_text": "{\"KeyWord\":\"91330000609786330F\",\"CaseIdentity\":\"1\",\"PageIndex\":1,\"PageSize\":10}",
        //   "date": "14.04.2025 18:20:42",
        //   "log_data": "",
        //   "service_code": "889",
        //   "total_count": "5",
        //   "first_name": "FirstName",
        //   "middle_name": "",
        //   "last_name": "LastName"
        // COMPUTED:
        //   "keyword": "91330000609786330F",
        //   "caseIdentity: "1",
        //   "page": "1",
        //   "response": {}  // parsed log_data
        // }
      ],
    };
  },
  mounted() {
    this.search();
  },
  methods: {
    handleToggleDetail(response = null) {
      this.response = response;
      this.modalShow = response !== null;
    },
    async search() {
      this.isLoading = true;
      try {
        const oldPage = this.page;
        const res = await axios.get(window.base + `/contract/getSearchLog?page=${oldPage}&pageSize=10&isLookup=6`);
        if (oldPage !== this.page) return;
        const data = res.data;
        this.histories = data.map((item) => {
          const search = JSON.parse(item.search_text);
          return {
            ...item,
            keyword: search.KeyWord,
            caseIdentity: search.CaseIdentity,
            page: search.PageIndex,
            response: JSON.parse(item.log_data),
          }
        });
        this.isLoading = false;
      } catch (e) {
        console.error("History lookup 6 error", e);
        this.isLoading = false;
      }
    },
    prevPage() {
      if (this.page > 1) {
        this.page--;
        this.search();
      }
    },
    nextPage() {
      this.page++;
      this.search();
    },
  },
};
</script>
<style>
.loader {
  border: 16px solid #f3f3f3;
  border-radius: 50%;
  border-top: 16px solid #3498db;
  width: 120px;
  height: 120px;
  -webkit-animation: spin 2s linear infinite;
  /* Safari */
  animation: spin 2s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>